import { get } from "svelte/store";
import { page } from "$app/stores";
import cfg from "$lib/config/config";
import type { RegionStore } from "$lib/stores/region";
import type { SelectEvent } from "$lib/components/RegionSelector/RegionSelectorModal/RegionSelectorModal.svelte";
import { base } from "$app/paths";
import { stripBasePath } from "$lib/utils/url";

/**
 * Navigate to a specific region/locale variant of the current current page
 */
export const gotoRegion = (
  {
    region,
    lang: locale,
    countryCode: country,
    defaultLanguage: defaultLocale,
  }: SelectEvent,
  regionInfo: RegionStore,
) => {
  const basePath = base || cfg.BASE_PATH;
  regionInfo.set({ region, country, locale });
  if (!locale) {
    locale = "";
  }
  // Get current page url path without language segment and/or base + language segments
  const $page = get(page);
  const pathname = stripBasePath($page.url.pathname);
  let currentPath = pathname;

  if (pathname.startsWith(`/${$page.params.lang}`)) {
    currentPath = currentPath.replace(`/${$page.params.lang}`, "");
  }

  if (pathname.startsWith(`${basePath}/${$page.params.lang}`)) {
    currentPath = currentPath.replace(`${basePath}/${$page.params.lang}`, "");
  }

  let url: URL;
  if (cfg.REGION_ID === "staging") {
    const defaultLang = cfg.DEFAULT_LOCALE;
    url = new URL(
      `${defaultLang === locale ? "" : `/${locale}`}${currentPath}`,
      window.location.origin,
    );
  } else {
    const useDefaultLang = defaultLocale && defaultLocale === locale;
    url = new URL(
      `/${region}${useDefaultLang ? "" : "/" + locale}${currentPath}`,
      window.location.origin,
    );
  }
  Object.entries($page.url.searchParams).forEach(param => {
    url.searchParams.append(param[0], param[1].toString());
  });
  if (!url.searchParams.has("brsr")) {
    url.searchParams.append("brsr", "true");
  }
  window.location.assign(url.href);
};
